import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, EcardLimitDialog } from '@dotcom/crown-ui';
import { getCurrentRegion } from '../../regional-config/get-regional-config';
import { ECardLimitModalProps } from './ecard-limit-modal-types';

export const ECardLimitModal = ({ onClose, isOpen }: ECardLimitModalProps) => {
  const { t } = useTranslation();
  const region = getCurrentRegion();

  const goToShopHallmark = () => {
    window.location.href = '/';
    onClose();
  };
  const goToJoinHallmark = () => {
    window.location.href = '/hallmarkplus-account/';
    onClose();
  };

  const ShopHallmarkButton = (
    <Button testId="shop-hallmark-btn" variant="secondary" onClick={goToShopHallmark}>
      {t('eCardLimit.shopHallmark')}
    </Button>
  );

  const JoinHallmarkButton = (
    <Button testId="join-hallmark-btn" variant="primary" onClick={goToJoinHallmark}>
      {t('eCardLimit.joinHallmark')}
    </Button>
  );

  return (
    <EcardLimitDialog
      title=""
      isOpen={isOpen}
      close={onClose}
      cancelButtonContent={ShopHallmarkButton}
      actionButtonContent={JoinHallmarkButton}
      locale={region}
    />
  );
};
